import AdvancedSearch from './AdvancedSearch';
import setRefinersVisibility from '../actions/setRefinersVisibility';
import { FILTERS_BUTTON_ID } from '../constants';
import getSearchRefinersButtonStrings from '../selectors/getSearchRefinersButtonStrings';
import { getStore } from '../store/store';
import isSharedFolderSearch from '../utils/isSharedFolderSearch';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { AriaProperties, AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import { logUsage } from 'owa-analytics';
import { isFeatureEnabled } from 'owa-feature-flags';
import { ControlIcons } from 'owa-control-icons';
import { SearchScenarioId } from 'owa-search-next';
import { onSearchRefinersToggled } from 'owa-search-next-lazy';
import * as React from 'react';

const styles = require('./SearchRefiners.scss');

@observer
export default class SearchRefiners extends React.Component<{}, {}> {
    render() {
        const searchRefinersButtonStrings = getSearchRefinersButtonStrings();
        const isAdvancedSearchVisible = getStore().isAdvancedSearchVisible;

        const ariaProperties: AriaProperties = {
            role: AriaRoles.button,
            hasPopup: true,
            label: searchRefinersButtonStrings.ariaLabel,
            expanded: isAdvancedSearchVisible,
        };

        // In case of shared folders, attachment refiner is not supported.
        const showAttachmentRefiner = !isSharedFolderSearch();

        return (
            <>
                {/* Button to toggle visiblity of refiners callout */}
                <button
                    id={FILTERS_BUTTON_ID}
                    className={styles.refinersButton}
                    onClick={this.onClick}
                    {...generateDomPropertiesForAria(ariaProperties)}>
                    {!isFeatureEnabled('sea-filterLabel3') &&
                        !isFeatureEnabled('sea-filterLabel4') && (
                            <span className={styles.refinersButtonText}>
                                {searchRefinersButtonStrings.buttonText}
                            </span>
                        )}
                    <Icon
                        iconName={
                            isFeatureEnabled('sea-filterLabel2') ||
                            isFeatureEnabled('sea-filterLabel4') ||
                            isFeatureEnabled('sea-filterLabel5')
                                ? ControlIcons.ChevronDown
                                : ControlIcons.Filter
                        }
                        className={styles.refinersButtonIcon}
                    />
                </button>

                {/* Callout with adjustable refiners */}
                {isAdvancedSearchVisible && (
                    <AdvancedSearch showAttachmentRefiner={showAttachmentRefiner} />
                )}
            </>
        );
    }

    private onClick = (evt: React.MouseEvent<unknown>) => {
        evt.stopPropagation();

        onSearchRefinersToggled(SearchScenarioId.Mail);

        // Determine search refiners visiblity.
        const isAdvancedSearchVisible = getStore().isAdvancedSearchVisible;
        const newIsAdvancedSearchVisible = !isAdvancedSearchVisible;

        // Log click on filters button, and if the click is to show or hide UI.
        logUsage('Search_AdvancedSearchButtonClicked', [
            newIsAdvancedSearchVisible,
            SearchScenarioId.Mail,
        ]);

        // Set visiblity of advanced search UI.
        setRefinersVisibility(newIsAdvancedSearchVisible);
    };
}
